import { render } from "./BaugrundstueckStep5c.vue?vue&type=template&id=077d5eff"
import script from "./BaugrundstueckStep5c.vue?vue&type=script&lang=js"
export * from "./BaugrundstueckStep5c.vue?vue&type=script&lang=js"

import exportComponent from "/Users/a98ca8a/projects/immo-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__